/* Kazanova · Octopix teması
   Etkileşimlerin çoğu belge düzeyinde dinlenir; böylece tema düzenleyicisi bir bölümü yeniden çizdiğinde de çalışır.
   Bölüme bağlı kurulumlar (hız çizgileri, ürün sayfası, çerez) baslat() içinde, shopify:section:load ile yeniden çalışır. */
document.documentElement.classList.add("js");
const $ = (s, k = document) => k.querySelector(s);
const $$ = (s, k = document) => [...k.querySelectorAll(s)];
const T = window.tema || {};

/* Kuruşu Türkçe biçimde yazar (sunucudaki tl snippet'iyle aynı): 550 TL, 699,90 TL, 1.000 TL */
function para(kurus) {
  const tam = Math.floor(kurus / 100), k = kurus % 100;
  return tam.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (k ? "," + String(k).padStart(2, "0") : "") + " " + (T.paraBirimi || "TL");
}

function bildir(metin) {
  const b = $(".bildirim");
  if (!b) return;
  b.textContent = metin;
  b.hidden = false;
  clearTimeout(bildir.t);
  bildir.t = setTimeout(() => (b.hidden = true), 3200);
}

/* Katmanlar: mobil menü, arama, sepet çekmecesi */
const perde = () => $("[data-perde]");
const cekmece = () => $("[data-sepet]");
const araEl = () => $("[data-ara]");
function menuKapat() {
  $("#menu")?.classList.remove("acik");
  $(".menu-ac")?.setAttribute("aria-expanded", "false");
}
function araKapat() { const a = araEl(); if (a) a.hidden = true; }
function sepetAc() {
  araKapat(); menuKapat();
  cekmece().hidden = false; perde().hidden = false;
  document.body.style.overflow = "hidden";
  $("[data-sepet-kapat]", cekmece())?.focus();
}
function sepetKapat() {
  const c = cekmece();
  if (!c || c.hidden) return;
  c.hidden = true; perde().hidden = true;
  document.body.style.overflow = "";
}

/* Sepet: Section Rendering API ile çekmece yeniden çizilir */
function sepetiYenile(sections, zipla) {
  const html = sections?.["sepet-cekmecesi"];
  if (!html) return;
  const yeni = $("[data-sepet]", new DOMParser().parseFromString(html, "text/html"));
  const eski = cekmece();
  yeni.hidden = eski.hidden;
  eski.replaceWith(yeni);
  /* sayfadaki diğer kargo çubukları (ürün sayfası) çekmecedekiyle aynı olsun */
  const bar = $("[data-kargo-bar]", yeni);
  if (bar) $$("[data-kargo-bar]").forEach(b => { if (!yeni.contains(b)) b.innerHTML = bar.innerHTML; });
  const adet = +yeni.dataset.adet || 0;
  $$("[data-sepet-sayi]").forEach(e => {
    e.textContent = adet; e.hidden = !adet;
    if (zipla) { e.classList.remove("zipla"); void e.offsetWidth; e.classList.add("zipla"); }
  });
}
async function sepetIstek(url, govde) {
  const r = await fetch(url + ".js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ ...govde, sections: "sepet-cekmecesi", sections_url: location.pathname }),
  });
  const veri = await r.json();
  if (!r.ok) throw new Error(veri.description || veri.message || T.hata);
  return veri;
}
async function sepeteEkle(kalemler) {
  const veri = await sepetIstek(T.sepetEkleUrl, { items: kalemler });
  sepetiYenile(veri.sections, true);
  sepetAc();
}

/* Arama önerileri: /search/suggest bölümü */
let araSayac, araIstek;
function oner(girdi) {
  const kutu = girdi.closest("[data-ara]"), sonuc = $("[data-ara-sonuc]", kutu);
  const q = girdi.value.trim();
  clearTimeout(araSayac); araIstek?.abort();
  if (q.length < 2) {
    sonuc.replaceChildren(...(kutu._bos ? [kutu._bos] : []));
    return;
  }
  araSayac = setTimeout(async () => {
    araIstek = new AbortController();
    const adres = `${T.oneriUrl || "/search/suggest"}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=arama-onerileri`;
    try {
      const html = await fetch(adres, { signal: araIstek.signal }).then(r => r.text());
      const oneriler = $("[data-oneriler]", new DOMParser().parseFromString(html, "text/html"));
      if (oneriler) sonuc.replaceChildren(oneriler);
    } catch (e) {}
  }, 180);
}

/* Tıklamalar */
document.addEventListener("click", async e => {
  const t = e.target;

  if (t.closest(".menu-ac")) {
    const ac = t.closest(".menu-ac");
    ac.setAttribute("aria-expanded", $("#menu").classList.toggle("acik"));
    return;
  }
  if (t.closest("#menu a")) menuKapat();

  if (t.closest("[data-ara-ac]")) {
    const a = araEl(); if (!a) return;
    e.preventDefault(); sepetKapat(); menuKapat();
    a._bos ??= $("[data-ara-bos]", a);
    a.hidden = false; $("[data-ara-girdi]", a).focus();
    return;
  }
  if (t.closest("[data-ara-kapat]") || t.matches("[data-ara]")) return araKapat();
  const oneri = t.closest("[data-oneri]");
  if (oneri) {
    const g = $("[data-ara-girdi]", oneri.closest("[data-ara]"));
    g.value = oneri.dataset.oneri; g.focus(); oner(g);
    return;
  }

  if (t.closest("[data-sepet-ac]") && cekmece() && !document.body.classList.contains("sablon-cart")) {
    e.preventDefault(); return sepetAc();
  }
  if (t.closest("[data-sepet-kapat]") || t.matches("[data-perde]")) return sepetKapat();

  const satir = t.closest("[data-satir]");
  if (satir) {
    const kok = cekmece(); kok.setAttribute("aria-busy", "true");
    try {
      const veri = await sepetIstek(T.sepetDegisUrl, { id: satir.dataset.satir, quantity: +satir.dataset.miktarYeni });
      sepetiYenile(veri.sections);
    } catch (hata) { bildir(hata.message); kok.removeAttribute("aria-busy"); }
    return;
  }

  /* kartlarda hızlı ekleme */
  const hizli = t.closest("[data-hizli-ekle]");
  if (hizli) {
    const yazi = hizli.textContent;
    hizli.disabled = true;
    try {
      await sepeteEkle([{ id: +hizli.dataset.hizliEkle, quantity: 1 }]);
      hizli.textContent = T.eklendi; hizli.classList.add("tamam");
      setTimeout(() => { hizli.textContent = yazi; hizli.classList.remove("tamam"); }, 1400);
    } catch (hata) { bildir(hata.message); }
    finally { hizli.disabled = false; }
    return;
  }

  /* sepet sayfası +/- */
  const miktar = t.closest("[data-miktar]");
  if (miktar) {
    const input = $("input", miktar.parentElement);
    input.value = Math.max(+input.min || 0, (+input.value || 0) + +miktar.dataset.miktar);
    input.dispatchEvent(new Event("change", { bubbles: true }));
    return;
  }

  /* katana cetveli: açık / katlanmış */
  const katla = t.closest("[data-katla]");
  if (katla) {
    const kok = katla.closest(".katla");
    $("[data-cetvel]", kok).classList.toggle("katlandi", katla.dataset.katla === "kapali");
    $$("[data-katla]", kok).forEach(x => { x.classList.toggle("secili", x === katla); x.setAttribute("aria-pressed", x === katla); });
    return;
  }

  /* çerez bildirimi */
  if (t.closest("[data-cerez-kabul]")) {
    try { localStorage.setItem("kz-cerez", "1"); } catch (hata) {}
    window.Shopify?.customerPrivacy?.setTrackingConsent?.({ analytics: true, marketing: true, preferences: true, sale_of_data: true }, () => {});
    t.closest("[data-cerez]").hidden = true;
  }
});

document.addEventListener("keydown", e => {
  if (e.key !== "Escape") return;
  sepetKapat(); araKapat(); menuKapat();
});

document.addEventListener("input", e => {
  if (e.target.matches("[data-ara-girdi]")) oner(e.target);
});

/* Değişince gönder: sıralama, filtre kutuları, sepet adedi */
document.addEventListener("change", e => {
  const el = e.target;
  if (el.matches("[data-otomatik-gonder]") || (el.closest("[data-filtre-form]") && el.type === "checkbox")) {
    clearTimeout(el._t);
    el._t = setTimeout(() => (el.form.requestSubmit ? el.form.requestSubmit() : el.form.submit()), el.type === "number" ? 500 : 0);
  }
});

document.addEventListener("submit", e => {
  const f = e.target;
  /* filtre formu: boş alanları adrese koyma */
  if (f.matches("[data-filtre-form]")) {
    e.preventDefault();
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(f)) if (v !== "") p.append(k, v);
    location.search = p.toString();
  }
  /* özel sipariş → WhatsApp */
  if (f.matches("[data-ozel]")) {
    e.preventDefault();
    const v = new FormData(f);
    const not = (v.get("not") || "").trim();
    const metin = (f.dataset.sablon || "[urun]\n[not]")
      .replace("[urun]", v.get("esya"))
      .replace(not ? "[not]" : /\n?[^\n]*\[not\][^\n]*/, not);
    window.open(`https://wa.me/${f.dataset.numara || T.whatsapp}?text=${encodeURIComponent(metin)}`, "_blank", "noopener");
  }
  /* adres silme onayı */
  if (f.matches("[data-onay]") && !confirm(f.dataset.onay)) e.preventDefault();
});

/* ÜRÜN SAYFASI */
function urunKur(kok) {
  const { varyantlar, stand } = JSON.parse($("[data-urun-veri]", kok).textContent);
  const form = $("[data-urun-form]", kok), idInput = $("[data-varyant-id]", kok);
  const ekle = $("[data-sepete]", kok), adetInput = $("[data-adet-sayi]", kok), standKutu = $("[data-stand]", kok);
  const sahne = kok.closest(".urun-sahne");
  const secenekSayisi = varyantlar[0]?.secenekler.length || 0;
  const bul = degerler => varyantlar.find(v => v.secenekler.every((d, i) => d === degerler[i]));
  let varyant = varyantlar.find(v => v.id === +idInput.value) || varyantlar[0];
  const adet = () => Math.max(1, +adetInput.value || 1);

  /* galeri: küçük görseller ve tam ekran */
  const anaKap = $("[data-isik-ac]", kok), ana = anaKap && $("img", anaKap);
  const kucukler = $$(".galeri-kucuk [data-medya]", kok);
  const isik = $("[data-isik]", sahne), isikImg = isik && $("[data-isik-img]", isik);
  let sira = 0;
  function goster(i) {
    if (!kucukler.length) return;
    sira = (i + kucukler.length) % kucukler.length;
    const k = kucukler[sira];
    kucukler.forEach(x => x.setAttribute("aria-current", x === k));
    if (ana) { ana.removeAttribute("srcset"); ana.src = k.dataset.buyuk; }
    if (isik?.open) { isikImg.src = k.dataset.tam; $("[data-isik-sayac]", isik).textContent = `${sira + 1} / ${kucukler.length}`; }
  }
  kucukler.forEach((k, i) => k.addEventListener("click", () => goster(i)));
  if (anaKap && isik) {
    anaKap.addEventListener("click", () => {
      const k = kucukler[sira];
      isikImg.src = k ? k.dataset.tam : ana.currentSrc || ana.src;
      isik.showModal(); document.body.style.overflow = "hidden";
      if (k) goster(sira);
    });
    isik.addEventListener("close", () => (document.body.style.overflow = ""));
    isik.addEventListener("click", e => {
      const git = e.target.closest("[data-isik-git]")?.dataset.isikGit;
      if (git === "kapat" || e.target === isik) isik.close();
      else if (git) goster(sira + +git);
    });
    isik.addEventListener("keydown", e => {
      if (e.key === "ArrowRight") goster(sira + 1);
      if (e.key === "ArrowLeft") goster(sira - 1);
    });
    let dokunX = null;
    isik.addEventListener("touchstart", e => { dokunX = e.touches[0].clientX; }, { passive: true });
    isik.addEventListener("touchend", e => {
      if (dokunX === null) return;
      const fark = e.changedTouches[0].clientX - dokunX; dokunX = null;
      if (Math.abs(fark) > 40) goster(sira + (fark < 0 ? 1 : -1));
    });
  }

  const ekleYazi = $("[data-sepete-yazi]", kok)?.textContent;
  function yaz() {
    const toplam = (varyant.fiyat + (standKutu?.checked && stand ? stand.fiyat : 0)) * adet();
    $("[data-fiyat]", kok).textContent = para(varyant.fiyat);
    $("[data-eski]", kok).textContent = varyant.eski > varyant.fiyat ? para(varyant.eski) : "";
    const t = $("[data-toplam]", kok); if (t) t.textContent = para(toplam);
    const yf = $("[data-yapiskan-fiyat]", sahne); if (yf) yf.textContent = para(toplam);
    idInput.value = varyant.id;
    ekle.disabled = !varyant.var;
    $$("[data-secenek]", kok).forEach(r => {
      const i = +r.dataset.secenek;
      const aday = bul(varyant.secenekler.map((d, j) => (j === i ? r.value : d)));
      r.closest("label").classList.toggle("tukendi", !aday || !aday.var);
    });
    if (varyant.medya) {
      const i = kucukler.findIndex(k => +k.dataset.medya === varyant.medya);
      if (i > -1) goster(i);
    }
  }
  $$("[data-secenek]", kok).forEach(r => r.addEventListener("change", () => {
    const v = bul(Array.from({ length: secenekSayisi }, (_, i) => $(`[data-secenek="${i}"]:checked`, kok)?.value));
    if (!v) return;
    varyant = v;
    const url = new URL(location.href);
    url.searchParams.set("variant", v.id);
    history.replaceState(null, "", url);
    yaz();
  }));
  $$("[data-adet]", kok).forEach(b => b.addEventListener("click", () => {
    adetInput.value = Math.max(1, Math.min(99, adet() + +b.dataset.adet)); yaz();
  }));
  adetInput.addEventListener("change", yaz);
  standKutu?.addEventListener("change", yaz);

  form.addEventListener("submit", async e => {
    e.preventDefault();
    if (!varyant.var) return;
    const yazi = $("[data-sepete-yazi]", kok);
    ekle.disabled = true; yazi.textContent = T.ekleniyor;
    const kalemler = [{ id: varyant.id, quantity: adet() }];
    if (standKutu?.checked && stand) kalemler.push({ id: stand.id, quantity: adet() });
    try { await sepeteEkle(kalemler); }
    catch (hata) { bildir(hata.message); }
    finally { ekle.disabled = !varyant.var; yazi.textContent = ekleYazi; }
  });

  /* mobilde yapışkan sepet çubuğu: ana düğme ekrandan çıkınca */
  const yap = $("[data-yapiskan]", sahne);
  if (yap) {
    $("[data-yapiskan-ekle]", yap).addEventListener("click", () => form.requestSubmit());
    new IntersectionObserver(([g]) => {
      const gorunur = !g.isIntersecting && g.boundingClientRect.top < 0;
      yap.classList.toggle("gorunur", gorunur);
      yap.setAttribute("aria-hidden", !gorunur);
      $("[data-yapiskan-ekle]", yap).tabIndex = gorunur ? 0 : -1;
    }).observe(ekle);
  }
  yaz();
}

/* Bölüme bağlı kurulumlar: sayfa açılışında ve düzenleyici bir bölümü yeniden çizdiğinde */
function baslat(kok) {
  /* açılış: manga hız çizgileri, panelin arkasındaki odaktan dışa */
  $$("[data-hiz]", kok).forEach(g => {
    let d = "";
    for (let i = 0; i < 90; i++) {
      const a = i / 90 * Math.PI * 2, r = 150 + i * 37 % 140, w = 1 + i * 13 % 5, c = Math.cos(a), s = Math.sin(a);
      d += `M${720 + c * r} ${470 + s * r}L${720 + c * 1400 - s * w} ${470 + s * 1400 + c * w}L${720 + c * 1400 + s * w} ${470 + s * 1400 - c * w}Z`;
    }
    g.innerHTML = `<path d="${d}"/>`;
  });
  /* çerez bildirimi bir kez sorulur; düzenleyicide her zaman görünür */
  $$("[data-cerez]", kok).forEach(kutu => {
    let kabul = false;
    try { kabul = localStorage.getItem("kz-cerez") === "1"; } catch (e) {}
    kutu.hidden = kabul && !window.Shopify?.designMode;
  });
  $$("[data-urun]", kok).forEach(urunKur);
}
baslat(document);
document.addEventListener("shopify:section:load", e => baslat(e.target));
/* düzenleyicide sepet bölümü seçilince çekmeceyi aç */
document.addEventListener("shopify:section:select", e => { if ($("[data-sepet]", e.target)) sepetAc(); });
document.addEventListener("shopify:section:deselect", e => { if ($("[data-sepet]", e.target)) sepetKapat(); });
